import { useCallback } from 'react';

import { useClient } from 'urql';

import {
  ScanToPayLoyaltyProfileDocument,
  type ScanToPayLoyaltyProfileQuery,
} from '../../graphql/ScanToPayLoyaltyProfile.generated';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for fetching the loyalty profile.
 */
export const useScanToPayLoyaltyProfile = () => {
  const client = useClient();

  // ─── Queries ──────────────────────────────────────────────────────────────

  const fetchLoyaltyProfile = useCallback(async () => {
    const queryLoyaltyProfile = client.query<ScanToPayLoyaltyProfileQuery>;

    const response = await queryLoyaltyProfile(
      ScanToPayLoyaltyProfileDocument,
      {},
      { requestPolicy: 'network-only' },
    ).toPromise();

    const loyaltyProfile = response.data?.loyaltyProfile;
    const availablePoints = loyaltyProfile?.points?.available ?? 0;
    const pointsRewards = loyaltyProfile?.pointsRewards ?? [];

    return { availablePoints, pointsRewards };
  }, [client.query]);

  // ──────────────────────────────────────────────────────────────────────────

  return { fetchLoyaltyProfile };
};
